{
    "translation": {
        "welcome": "Bienvenido",
        "home": "Inicio",
        "find_pro": "Buscar un Profesional",
        "admin": "Admin",
        "my_space": "Mi Espacio",
        "login": "Iniciar Sesión",
        "logout": "Cerrar Sesión",
        "search_placeholder": "Peluquero, Barbero, Manicura...",
        "hero_title": "Reserva tu cita de belleza",
        "hero_subtitle": "Encuentra los mejores profesionales cerca de ti.",
        "hero_welcome": "Bienvenido a OpenGlow",
        "hero_slogan": "La excelencia al alcance de tu mano.",
        "hero_desc": "Reserva tus tratamientos de belleza y bienestar en pocos clics. Simple, rápido y elegante.",
        "search_btn": "Buscar",
        "popular_services": "Servicios Populares",
        "footer_rights": "Todos los derechos reservados.",
        "footer_about_us": "Quienes somos",
        "legal_mentions": "Menciones Legales",
        "cgp": "Condiciones Generales de Prestación",
        "feature_search_title": "Buscar",
        "feature_search_desc": "Encuentra los mejores salones y expertos cerca de ti",
        "feature_book_title": "Reservar",
        "feature_book_desc": "Elige tu horario ideal en segundos",
        "feature_enjoy_title": "Disfrutar",
        "feature_enjoy_desc": "Vive una experiencia de belleza única y relajante",
        "featured_pros_title": "Profesionales Destacados",
        "reviews_count": "reseñas",
        "client_space": "ÁREA DE CLIENTE",
        "my_bookings": "Mis Reservas",
        "explore_map": "Explorar Mapa",
        "edit_photo": "Editar Foto",
        "photo_updated": "¡Foto de perfil actualizada!",
        "error_upload": "Error al subir la foto.",
        "search_action": "Buscar",
        "filters_all": "Todos",
        "filter_sort": "Filtros",
        "filter_distance_nearest": "Distancia: más cerca",
        "filter_rating_highest": "Valoración: mejor",
        "filter_reviews_most": "Reseñas: más numerosas",
        "filter_name_az": "Nombre: A-Z",
        "filter_min_rating": "Valoración mínima",
        "filter_max_distance": "Distancia máxima",
        "show_filters": "Mostrar filtros",
        "hide_filters": "Ocultar filtros",
        "map_style": "Estilo",
        "map_enable_location_filter": "Activa la ubicación para filtrar por distancia",
        "profession_hairdresser": "Peluquero",
        "profession_esthetician": "Esteticista",
        "profession_barber": "Barbero",
        "profession_manicure": "Manicura",
        "profession_masseur": "Masajista",
        "settings_title": "Ajustes",
        "settings_back": "Volver",
        "settings_section_appearance": "Apariencia",
        "settings_theme_intro": "Elige el tema de la aplicación.",
        "settings_theme_classic": "Blanco y Negro",
        "settings_theme_ocean": "Océano",
        "settings_theme_rose": "Rosa",
        "settings_theme_dark": "Oscuro",
        "settings_theme_night": "Noche",
        "settings_compact_mode": "Modo compacto",
        "settings_compact_mode_sub": "Reduce el espaciado de esta página",
        "settings_section_notifications": "Notificaciones",
        "settings_notif_email": "Correos de reserva",
        "settings_notif_email_sub": "Confirmaciones y recordatorios de citas",
        "settings_notif_push": "Centro de notificaciones",
        "settings_notif_push_sub": "Alertas en la aplicación",
        "settings_notif_marketing": "Noticias y ofertas",
        "settings_notif_marketing_sub": "Actualizaciones de productos y promociones",
        "settings_section_account": "Cuenta",
        "settings_account_profile": "Perfil",
        "settings_account_email_label": "Dirección de correo",
        "settings_not_connected": "No conectado",
        "settings_section_security": "Seguridad",
        "settings_pwd_title": "Cambiar contraseña",
        "settings_pwd_hint": "Elige una contraseña segura (12+ car., mayúscula, número, símbolo)",
        "settings_pwd_current": "Contraseña actual",
        "settings_pwd_new": "Nueva contraseña",
        "settings_pwd_confirm": "Confirmar nueva contraseña",
        "settings_pwd_submit": "Guardar contraseña",
        "settings_pwd_submitting": "Guardando…",
        "about_title": "Quienes somos",
        "about_intro": "OpenGlow es una plataforma francesa que simplifica la conexion entre clientes y profesionales de la belleza.",
        "about_mission_title": "Nuestra mision",
        "about_mission_text": "Ayudar a cada persona a encontrar rapidamente un profesional de confianza cerca de ella, con una experiencia de reserva simple, transparente y moderna.",
        "about_build_title": "Lo que construimos",
        "about_build_item_1": "Un espacio de cliente claro para buscar, reservar y seguir sus citas.",
        "about_build_item_2": "Un espacio profesional para gestionar agenda, servicios, resenas y anuncios.",
        "about_values_title": "Nuestros valores",
        "about_values_simple_label": "Simplicidad:",
        "about_values_simple_text": "una interfaz rapida de entender para todos.",
        "about_values_trust_label": "Confianza:",
        "about_values_trust_text": "informacion clara y perfiles verificados.",
        "about_values_respect_label": "Respeto:",
        "about_values_respect_text": "proteccion de datos personales y enfoque responsable.",
        "about_values_exigence_label": "Exigencia:",
        "about_values_exigence_text": "mejora continua de la experiencia de usuario.",
        "about_contact_title": "Contacto",
        "about_contact_line_1": "Tiene una pregunta o necesita ayuda?",
        "about_contact_line_2": "Utilice el chat interno del sitio para una respuesta mas rapida.",
        "about_contact_line_3": "Para cualquier otra solicitud, escribanos a",
        "settings_show_pwd": "Mostrar",
        "settings_hide_pwd": "Ocultar",
        "passwords_mismatch": "Las contraseñas no coinciden.",
        "password_change_success": "Contraseña cambiada con éxito.",
        "password_change_error": "Error al cambiar la contraseña.",
        "network_error_retry": "Error de red. Por favor, inténtelo de nuevo."
    }
}